import { Directive, ElementRef, HostListener, SecurityContext} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
    selector: '[sanitizeInput]',
    standalone: false
})
export class SanitizeInputDirective {
  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly el: ElementRef,
  ) {}

  /** 
    * Sanitizing user entered text using DOMSanitizer.
    *
    * The special characters & " < > are converted to the following encoding while sanitization is done.
    * 
    * & - &amp;
    * " - &quot; or &#34; 
    * < - &lt;
    * > - &gt;
    * 
    * 
    * So we are replacing them with empty string using a regex if they are present in the string even when pasted.
    * 
    * If we find a future need to allow any of these characters to be included, we can customize accordingly.
    */

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    let sanitized = this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
        sanitized = sanitized.replace(/<[^>]*>|&lt;|&gt;/g, '');    
        if (value !== sanitized) {
          this.el.nativeElement.value = sanitized;
        }
  }
}